<template>
  <div id="supervision">
    <div class="row">
      <div class="col">
        <div class="page-title-box flex-between flex-align-center">
          <h4 class="page-title">课程学生行为统计</h4>
          <div v-if="this.countArea !== ''" class="page-title date-range">
            统计范围：{{ countArea }}
          </div>
        </div>
      </div>
    </div>
    <div class="mb-2 flex-between flex-align-center">
      <div class="select-auto-fit-style">
        <el-select
          class="schoolyear range-condition"
          v-model="schoolyear"
          @change="handleSchoolyear"
          placeholder="请选择学期"
          filterable
        >
          <template slot="prefix">
            {{ (schoolyearOption.find(v => v.id === schoolyear) || {}).name }}
          </template>
          <el-option
            v-for="item in schoolyearOption"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          class="institute range-condition"
          v-model="institute"
          @change="handleInstitute"
          placeholder="请选择学院"
          filterable
        >
          <template slot="prefix">
            {{ (instituteOption.find(v => v.id === institute) || {}).name }}
          </template>
          <el-option
            v-for="item in instituteOption"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :class="!item.disabled && item.env === 'sysu' ? 'level2-option' : ''"
          ></el-option>
        </el-select>
        <el-select
          v-if="curEnv !== 'sysu' && curEnv !== 'gk'"
          class="coursetype range-condition"
          v-model="coursetype"
          @change="handleCoursetype"
          placeholder="请选择课程类型"
        >
          <template slot="prefix">
            {{ (coursetypeOption.find(v => v.id === coursetype) || {}).name }}
          </template>
          <el-option
            v-for="item in coursetypeOption"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <el-card>
      <div class="mb-3 flex-between table-inner-filter">
        <div class="">
          <div class="flex">
            <el-input
              v-model="keyword"
              placeholder="搜索课程名称"
              @change="handleKeyword"
            ></el-input>
            <el-button class="search-icon" type="primary" @click="handleKeyword">
              <i class="mdi mdi-magnify"></i>
            </el-button>
          </div>
        </div>
        <div class="">
          <div class="page-title date-range">
            时间范围：日报
            <el-date-picker
              v-model="day"
              type="date"
              value-format="yyyy-MM-dd"
              @change="handleDay"
              placeholder="选择日期"
              :picker-options="dayPickerOptions"
            ></el-date-picker>
            /&nbsp;周报
            <el-date-picker
              v-model="week"
              type="week"
              format="yyyy 第 WW 周"
              @change="handleWeek"
              placeholder="选择周"
              :picker-options="weekPickerOptions"
            ></el-date-picker>
            /&nbsp;月报
            <el-date-picker
              v-model="month"
              type="month"
              value-format="yyyy-MM"
              @change="handleMonth"
              placeholder="选择月"
              :picker-options="monthPickerOptions"
            ></el-date-picker>
            <el-button class="dowmload-btn" type="primary" size="medium" @click="exportTable">
              <i class="mdi mdi-download"></i>
              下载表格
            </el-button>
          </div>
        </div>
      </div>
      <div class="list-box">
        <!-- <div class="leftMove move" style="cursor: pointer" @click="moveTable(0)">
          <i class="fa fa-chevron-left"></i>
        </div> -->
        <el-table
          ref="studentStatsTable"
          id="student-stats-table"
          class="mb-3"
          :data="studentData"
          row-key="id"
          default-expand-all
          stripe=""
          max-height="750"
          @mousedown.native="mouseDownHandler"
          @mouseup.native="mouseUpHandler"
          @mousemove.native="mouseMoveHandler"
        >
          <el-table-column
            prop="course_id"
            label="ID"
            :width="flexWidth('course_id', studentData, 'ID')"
            fixed
          ></el-table-column>
          <el-table-column
            prop="college"
            label="学院"
            :width="flexWidth('college', studentData, '学院')"
            fixed
          ></el-table-column>
          <el-table-column
            prop="fullname"
            label="课程"
            :width="flexWidth('fullname', studentData, '课程')"
            fixed
          ></el-table-column>
          <el-table-column prop="idnumber" label="课程编号" width="200"></el-table-column>
          <el-table-column prop="student" label="学生数" width="70"></el-table-column>
          <el-table-column prop="active_student" label="活跃学生数" width="90"></el-table-column>
          <el-table-column prop="access_num" label="课程访问数" width="90"></el-table-column>
          <el-table-column prop="assign" label="作业提交数" width="90">
            <template slot-scope="scope">
              <div>{{ scope.row.assign.submit }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="assign" label="作业迟交数" width="90">
            <template slot-scope="scope">
              <div>{{ scope.row.assign.late }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="assign" label="作业未交数" width="90">
            <template slot-scope="scope">
              <div>{{ Number(scope.row.assign.not_submit) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="quiz" label="测验提交数" width="90">
            <template slot-scope="scope">
              <div>{{ scope.row.quiz.submit }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="quiz" label="测验未交数" width="90">
            <template slot-scope="scope">
              <div>{{ Number(scope.row.quiz.not_submit) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="forum" label="讨论主题数" width="90">
            <template slot-scope="scope">
              <div>{{ scope.row.forum.discussion }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="forum" label="回帖数">
            <template slot-scope="scope">
              <div>{{ scope.row.forum.post }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="forum" label="从未参与讨论学生数" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.forum.not_participate }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="spend_time" label="在线时长(分)" width="110"></el-table-column>
          <el-table-column
            prop="finish_rate"
            label="平均课程完成率(%)"
            width="150"
          ></el-table-column>
          <el-table-column prop="grade" label="平均分"></el-table-column>
          <el-table-column prop="updated_time" label="更新时间" width="160"></el-table-column>
        </el-table>
        <!-- <div class="rightMove move" style="cursor: pointer" @click="moveTable(1)">
          <i class="fa fa-chevron-right"></i>
        </div> -->
      </div>
      <el-row v-if="this.totalSize > 0" class="flex-between flex-align-center">
        <el-col>
          <div class="total-course">共计&nbsp;{{ totalSize }}&nbsp;门课程</div>
        </el-col>
        <Pagination
          :totalSize="totalSize"
          :currentPage="currentPage"
          @setPageSizesVal="getPageSizesVal"
          @setCurPageVal="getCurPageVal"
        ></Pagination>
      </el-row>
    </el-card>

    <div class="row"></div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue'
import { timestampToTime } from '@/utils/format.js'
import { getCascader, getLastDate, getEndDate, weekJudge } from '@/utils/format.js'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      countArea: '',
      // 筛选数据
      day: '',
      week: '',
      weekTime: '',
      month: '',
      dayPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now() - 86400000
        },
      },
      weekPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now() - 86400000
        },
      },
      monthPickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 86400000
        },
      },
      schoolyear: '0',
      schoolyearOption: [],
      institute: '0',
      instituteOption: [],
      studentData: [],
      coursetype: 0,
      coursetypeOption: [
        { id: 0, name: '所有课程类型' },
        { id: 1, name: '本科' },
        { id: 2, name: '研究生' },
        { id: 3, name: '其他' },
        { id: 4, name: '培训课程' },
      ],
      // 页码数据
      totalSize: null,
      currentPage: 1,
      pageSizesVal: 10,
      // 鼠标拖动表格滚动
      mouseFlag: false,
      mouseOffset: 0,
      // 关键字搜索
      keyword: '',
    }
  },
  computed: {
    curEnv() {
      console.log(process.env.VUE_APP_MODE)
      return process.env.VUE_APP_MODE
    },
  },
  mounted() {
    Promise.all([this.getSemesterApi(), this.getCollegeApi()])
      .then(() => {
        this.getCourseStudentStatsApi()
      })
      .catch(err => {
        this.$message.warning(err)
      })
  },
  methods: {
    // 表格单元格自适应宽度
    flexWidth(prop, tableData, title, num = 0) {
      if (tableData.length === 0) {
        //表格没数据不做处理
        return
      }
      let flexWidth = 0 //初始化表格列宽
      let columnContent = '' //占位最宽的内容
      let canvas = document.createElement('canvas')
      let context = canvas.getContext('2d')
      context.font = '14px Microsoft YaHei'
      if (prop === '' && title) {
        //标题长内容少的，取标题的值,
        columnContent = title
      } else {
        // 获取该列中占位最宽的内容
        let index = 0
        for (let i = 0; i < tableData.length; i++) {
          const now_temp = tableData[i][prop] + ''
          const max_temp = tableData[index][prop] + ''
          const now_temp_w = context.measureText(now_temp).width
          const max_temp_w = context.measureText(max_temp).width
          if (now_temp_w > max_temp_w) {
            index = i
          }
        }
        columnContent = tableData[index][prop]
        //比较占位最宽的值跟标题、标题为空的留出四个位置
        const column_w = context.measureText(columnContent).width
        const title_w = context.measureText(title).width
        if (column_w < title_w) {
          columnContent = title || '留四个字'
        }
      }
      // 计算最宽内容的列宽
      let width = context.measureText(columnContent)
      flexWidth = width.width + 40 + num
      return flexWidth + 'px'
    },
    // 鼠标点击滚动按钮
    moveTable(isRight) {
      let { scrollLeft } = this.$refs.studentStatsTable.bodyWrapper
      if (isRight) {
        this.$refs.studentStatsTable.bodyWrapper.scrollLeft = scrollLeft + 150
      } else {
        this.$refs.studentStatsTable.bodyWrapper.scrollLeft = scrollLeft - 150
      }
    },
    handleDay(val) {
      this.week = ''
      this.weekTime = ''
      this.month = ''
      console.log(val)
      console.log(this.day)
      if (val) {
        this.countArea = this.day.split('-').join('.')
      } else {
        this.countArea = ''
      }
      this.getCourseStudentStatsApi()
    },
    handleWeek(val) {
      this.day = ''
      this.month = ''
      let todayDay = val ? new Date(val) : new Date()
      let todayOfWeek = todayDay.getDay()
      let spendDay = 1
      if (todayOfWeek !== 0) {
        spendDay = 7 - todayOfWeek // 开始时间到结束时间还有几天
      }
      let startTimeStr = timestampToTime(todayDay.valueOf() - (6 - spendDay) * 86400000) // 时间戳转字符串
      let endTimeStr = timestampToTime(todayDay.valueOf() + spendDay * 86400000)
      this.weekTime = startTimeStr + '~' + endTimeStr // 选择的范围
      console.log(this.weekTime)
      if (val) {
        if (weekJudge(new Date(this.weekTime.split('~')[0]))) {
          this.countArea = this.weekTime.split('~')[0] + '~' + getLastDate()
        } else {
          this.countArea = this.weekTime.split('-').join('.')
        }
      } else {
        this.countArea = ''
      }
      this.getCourseStudentStatsApi()
    },
    handleMonth(val) {
      this.day = ''
      this.week = ''
      this.weekTime = ''
      console.log(val)
      if (val) {
        this.countArea = `${this.month.split('-').join('.')}.01`
        let curMonth = new Date()
        curMonth =
          curMonth.getMonth() + 1 < 10 ? '0' + (curMonth.getMonth() + 1) : curMonth.getMonth() + 1
        if (this.countArea.substring(5, 7) === curMonth) {
          if (new Date().getDate !== 1) {
            this.countArea += '~' + getLastDate()
          }
        } else {
          this.countArea +=
            '~' +
            this.month +
            '.' +
            getEndDate(this.month.substring(0, 4), this.month.substring(5, 7))
        }
      } else {
        this.countArea = ''
      }

      this.getCourseStudentStatsApi()
    },
    handleSchoolyear(val) {
      console.log(val)
      this.getCourseStudentStatsApi()
    },
    handleInstitute(val) {
      console.log(val)
      this.getCourseStudentStatsApi()
    },
    handleCoursetype(val) {
      console.log(val)
      this.getCourseStudentStatsApi()
    },
    handleKeyword() {
      this.getCourseStudentStatsApi()
    },
    async getCourseStudentStatsApi(type = '') {
      await this.$store
        .dispatch('supervision/getCourseStudentStats', {
          semester_id: +this.schoolyear,
          category_id: +this.institute,
          type: this.coursetype,
          day: this.day,
          week: this.weekTime,
          month: this.month,
          page: this.currentPage,
          pagesize: this.pageSizesVal,
          print: type === 'download' ? 1 : 0,
          responseType: type === 'download' ? 'blob' : '',
          keyword: this.keyword,
        })
        .then(res => {
          if (type === 'download') {
            const link = document.createElement('a') // 创建a标签
            let blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            }) //文件流处理
            link.style.display = 'none' //去除a标签的样式
            // 设置连接
            link.href = URL.createObjectURL(blob)
            link.download = '课程学生行为统计'
            document.body.appendChild(link)
            //模拟点击事件
            link.click()
            //移除创建的a标签
            window.URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          } else if (res.code === 1) {
            console.log('res:', res)
            this.studentData = res.data.list
            this.totalSize = res.data.paging.records
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    async getSemesterApi() {
      await this.$store
        .dispatch('commom/getSemester')
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.schoolyearOption = res.data
            if (this.schoolyearOption.length > 0) {
              this.schoolyear = this.schoolyearOption[0].id
            }
            this.schoolyearOption = [
              {
                id: '0',
                name: '全部学期',
              },
            ].concat(this.schoolyearOption)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    async getCollegeApi() {
      await this.$store
        .dispatch('commom/getCollege')
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.instituteOption = []
            console.log('appmode')
            let treeData = getCascader(res.data)
            switch (process.env.VUE_APP_MODE) {
              case 'sysu':
                for (let firstLevelItem of treeData) {
                  firstLevelItem.env = 'sysu'
                  this.instituteOption.push(firstLevelItem)
                  let childNodes = firstLevelItem.children
                  // 对每一个子节点都进行深度优先遍历
                  if (childNodes.length) {
                    childNodes.forEach(item => {
                      item.env = 'sysu'
                      this.instituteOption.push(item)
                    })
                  }
                }
                break
              default:
                for (let firstLevelItem of treeData) {
                  firstLevelItem.env = 'others'
                  firstLevelItem.disabled = false
                  this.instituteOption.push(firstLevelItem)
                }
                break
            }
            this.instituteOption = [
              {
                id: '0',
                name: '全部学院',
              },
            ].concat(this.instituteOption)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 页码操作
    getPageSizesVal(pageSizesVal) {
      this.pageSizesVal = pageSizesVal
      this.getCourseStudentStatsApi()
    },
    getCurPageVal(curPageVal) {
      this.currentPage = curPageVal
      this.getCourseStudentStatsApi()
    },
    exportTable() {
      this.getCourseStudentStatsApi('download')
    },
    // 鼠标拖动表格滚动
    // 按下鼠标记录鼠标位置
    mouseDownHandler(e) {
      this.mouseOffset = e.clientX
      this.mouseFlag = true
    },
    mouseUpHandler(e) {
      this.mouseFlag = false
    },
    mouseMoveHandler(e) {
      let divData = this.$refs.studentStatsTable.bodyWrapper
      if (this.mouseFlag) {
        // 设置水平方向的元素的位置
        divData.scrollLeft -= -this.mouseOffset + (this.mouseOffset = e.clientX)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .schoolyear.el-select .el-input__inner {
    min-width: 240px;
    padding-left: 0;
    border: none;
    background: none;
    font-size: 20px;
    font-weight: bold;
    color: #3294f6;
  }
  .institute.el-select .el-input__inner {
    min-width: 240px;
    padding-left: 0;
    border: none;
    background: none;
    font-size: 20px;
    font-weight: bold;
    color: #3294f6;
  }
  .coursetype.el-select .el-input__inner {
    min-width: 180px;
    padding-left: 0;
    border: none;
    background: none;
    font-size: 20px;
    font-weight: bold;
    color: #3294f6;
  }
  .el-select .el-input .el-select__caret {
    color: #3294f6;
    font-weight: bold;
  }
  .el-select {
    .el-input__inner::placeholder {
      color: #3294f6;
    }
  }
  .el-input {
    .el-input__inner {
      border-radius: 3px;
    }
  }
  .el-button.el-button--primary.search-icon {
    width: 56px;
    height: 40px;
    padding: 11px;
    border-radius: 3px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 160px;
  }
  .el-table {
    .el-table__header-wrapper,
    .el-table__fixed-header-wrapper {
      table.el-table__header {
        th.el-table__cell {
          border-top: 1px solid #ebeef5;
        }
      }
    }
  }
  .select-auto-fit-style {
    .el-input__prefix {
      // prefix与input的样式保持一致，这样才能与原来重合对齐
      font-size: 20px;
      font-weight: bold;
      line-height: 40px;
      padding-right: 30px;
      left: 0;
      position: relative;
      visibility: hidden;
      text-align: center;
    }
    .el-input__inner {
      position: absolute;
    }
    .el-input__suffix {
      right: 0;
    }
  }
}
.mdi.mdi-magnify {
  font-size: 25px;
  line-height: 18px;
}
h4.page-title {
  font-weight: 600;
}
.date-range {
  font-size: 14px;
  color: #6c757d;
  line-height: 19px;
}
.range-condition {
  margin-right: 24px;
}
.sub-chapter {
  font-size: 10px;
  color: #98a6ad;
}
.dowmload-btn {
  margin-left: 12px;
}
.level2-option {
  padding-left: 30px;
}
.list-box {
  display: flex;
  padding: 0 28px;
  .move {
    width: 28px;
    position: relative;
    cursor: pointer;
    i {
      color: #999999;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.table-inner-filter {
  padding: 0 28px;
}
.total-course {
  margin-left: 24px;
  font-size: 14px;
  font-weight: bold;
  color: #6c757d;
}
</style>
